import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { buildWaUrl } from "@/lib/whatsapp";
import { DisplayName } from "@/lib/name";

function formatBR(date) {
 if (!date) return "";
 const [y, m, d] = date.split("-");
 return `${d}/${m}/${y}`;
}

function dayLabel(days) {
 if (days === 0) return { txt: "Hoje! 🎉", cls: "pill-green" };
 if (days === 1) return { txt: "Amanhã", cls: "pill-amber" };
 if (days<= 7) return { txt: `Em ${days} dias`, cls: "pill-amber" };
 return { txt: `Em ${days} dias`, cls: "pill-slate" };
}

export default function BirthdaysTab() {
 const [items, setItems] = useState([]);
 const [loading, setLoading] = useState(true);
 const [windowDays, setWindowDays] = useState(30);
 const [template, setTemplate] = useState("");
 const [savedTemplate, setSavedTemplate] = useState("");
 const [savingTpl, setSavingTpl] = useState(false);

 const load = async () =>{
 setLoading(true);
 try {
 const { data } = await api.get("/clients/birthdays", { params: { days: windowDays } });
 setItems(data);
 } catch (e) {
 toast.error(formatApiError(e.response?.data?.detail));
 } finally {
 setLoading(false);
 }
 };

 const loadSettings = async () =>{
 try {
 const { data } = await api.get("/settings");
 setTemplate(data.birthday_template || "");
 setSavedTemplate(data.birthday_template || "");
 } catch {}
 };

 useEffect(() =>{ load(); }, [windowDays]);
 useEffect(() =>{ loadSettings(); }, []);

 const saveTemplate = async () =>{
 setSavingTpl(true);
 try {
 const { data } = await api.put("/settings", { birthday_template: template });
 setSavedTemplate(data.birthday_template);
 toast.success("Mensagem padrão salva ✅");
 } catch (e) {
 toast.error(formatApiError(e.response?.data?.detail));
 } finally {
 setSavingTpl(false);
 }
 };

 const resetTemplate = () =>setTemplate(savedTemplate);

 const hasChanges = template !== savedTemplate;

 return (<div data-testid="birthdays-tab" className="grid grid-cols-1 lg:grid-cols-3 gap-6">{/* Left: editable template */}<div className="lg:col-span-1"><div className="soft-card p-5 sticky top-20" data-testid="birthday-template-card"><h2 className="text-lg font-bold display text-slate-900">Mensagem padrão</h2><p className="text-slate-500 text-sm mt-1">Edite à vontade. Esta mensagem é enviada via WhatsApp.</p><Textarea
 rows={10}
 value={template}
 onChange={(e) =>setTemplate(e.target.value)}
 className="mt-3 font-mono text-sm bg-white"
 placeholder="Digite a mensagem..."
 data-testid="birthday-template-textarea"
 /><div className="mt-3 flex gap-2"><Button onClick={saveTemplate} disabled={savingTpl || !hasChanges}
 className="brand-grad text-white" size="sm"
 data-testid="birthday-template-save">{savingTpl ? "Salvando..." : "Salvar mensagem"}</Button>{hasChanges && (<Button variant="ghost" size="sm" onClick={resetTemplate}
 data-testid="birthday-template-reset">Descartar</Button>)}</div></div></div>{/* Right: birthday cards */}<div className="lg:col-span-2"><div className="flex items-center justify-between gap-3 mb-5"><div><h2 className="text-xl font-bold display text-slate-900">Aniversariantes</h2><p className="text-slate-500 text-sm">Aproveite a data para um carinho com seu cliente.</p></div><div className="flex gap-1 bg-white border border-slate-200 rounded-full p-1">{[7, 30, 90].map((d) =>(<button
 key={d}
 onClick={() =>setWindowDays(d)}
 className={`px-3 py-1.5 rounded-full text-xs font-semibold transition ${
                  windowDays === d ? "bg-[#0b3a82] text-white" : "text-slate-600 hover:bg-slate-50"
                }`}
 data-testid={`birthday-window-${d}`}
 >{d}d</button>))}</div></div>{loading ? (<div className="text-slate-500 text-center py-12" data-testid="birthdays-loading">Carregando...</div>) : items.length === 0 ? (<div className="soft-card p-10 text-center" data-testid="birthdays-empty"><div className="text-5xl mb-3" aria-hidden></div><div className="text-lg font-semibold text-slate-900">Nenhum aniversariante</div><p className="text-slate-500 mt-1">Não há datas nos próximos {windowDays} dias.</p></div>) : (<div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="birthdays-grid">{items.map((c) =>{
 const lbl = dayLabel(c.days_until);
 const waUrl = buildWaUrl(c.phone, savedTemplate || template);
 return (<div key={c.client_id} className="soft-card p-5" data-testid={`birthday-card-${c.client_id}`}><div className="flex items-start justify-between gap-3"><div><div className="text-lg font-semibold text-slate-900"><DisplayName name={c.full_name} /></div><div className="text-xs text-slate-500 mt-0.5">{formatBR(c.birth_date)}
 {c.turning_age != null && (<><span className="divider-dot" />Faz<b className="text-slate-700">{c.turning_age}</b>anos</>)}</div></div><span className={`pill ${lbl.cls}`}>{lbl.txt}</span></div><div className="mt-3 text-sm text-slate-600 space-y-1"><div><span className="ml-1">{c.phone}</span></div>{c.email &&<div><span className="ml-1">{c.email}</span></div>}</div><div className="mt-4 pt-3 border-t border-slate-100">{c.phone ? (<a href={waUrl} target="_blank" rel="noreferrer"
 data-testid={`birthday-wa-${c.client_id}`}><Button size="sm" className="bg-[#25D366] hover:bg-[#1ebe5d] text-white">Enviar parabéns</Button></a>) : (<span className="text-xs text-slate-400">Sem telefone cadastrado</span>)}</div></div>);
 })}</div>)}</div></div>);
}
